import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function UserGroupEditForm({ 
  userGroup,
  btnRef,
  saveUserGroup
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={userGroup}
      onSubmit={(values) => saveUserGroup(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Adı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="definition">
            <Form.Label column sm={2}>
              Açıklaması
            </Form.Label>
            <Col sm={10}>
              <Form.Control as="textarea" rows="3" value={values.definition} placeholder="Açıklaması" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}